import { render } from "./FormattedDatetime.vue?vue&type=template&id=96f66fe0"
import script from "./FormattedDatetime.vue?vue&type=script&lang=js"
export * from "./FormattedDatetime.vue?vue&type=script&lang=js"
script.render = render

export default script